import { getFetch } from '../fetch';

import { apiConfig } from '../config';

import { StudentClessonResults } from '../../../typings';

export function getStudentCLessonResults(clessonId: number, studentId: number): Promise<StudentClessonResults> {
    const { apiGetStudentCLessonResults } = apiConfig.getStaticUrls();

    return getFetch(apiGetStudentCLessonResults, { clessonId, student: studentId });
}
